const addProductToCart = (e) => {
  e.preventDefault();
  const loader = document.querySelector('#load_overlay')

  loader.style.display = 'block';

  const { href: cartURL } = e.target.dataset;
  let varianturl = new URL(cartURL);
  let pathdata = varianturl.pathname.replace("/cart/", "").split(",");

  const urlParams = new URLSearchParams(varianturl.search);
  const discount = urlParams.get("discount");

  var items = [];
  pathdata.forEach((id) => {
    items.push({
      id: id.split(":")[0],
      quantity: id.split(":")[1],
    });
  });

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ items }),
  })
    .then((addOnResponse) => {
      loader.style.display = 'none';
      return addOnResponse.json();
    })
    .catch((error) => {
      loader.style.display = 'none';
      console.error("Error:", error);
    });
};

const addToCartButtons = document.querySelectorAll(
  "button.buy-now-btn,.drawer-cart-button"
);

addToCartButtons.forEach((button) => {
  button.addEventListener("click", addProductToCart);
});

